webpackJsonp([50],{

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var swRegistration = null;
var isSubscribe = false;
var applicationServerPublicKey = 'BO_R6m8osilNmdOhEHk-KF0o1u-EPruOL1bDaISHwDwSLacPsh35Hg41nZpS00XeCLG-KbGEqx35x6PKsdZNVCk';
(function () {
    var btn = document.querySelector('button');

    if ('serviceWorker' in navigator && 'PushManager' in window) {
        navigator.serviceWorker.register('sw.js').then(function (swReg) {
            swRegistration = swReg;
            //console.log(swRegistration);
            //alert("q");
            //btn.addEventListener('click', btnClick, true);
        }).catch(function (error) {
            console.error('Service Worker Error', error);
        });
    } else {
        console.warn('Push messaging is not supported');
        btn.textContent = 'Push Not Supported';
    }
})();

/***/ })

},[162]);


// WEBPACK FOOTER //
// static/js/registerSw.ead92ad476c0ca405007.js